import api from "@/services/api.service";
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'edit',
  components: {},
  props: [],
  data () {
    return {
      caption:"Edit Weighatge",
      formField:{value:'',label:''},
      submitStatus: null,
      permission_list: false,
      superAdmin: false
    }
  },
  computed: {    
  },
  watch:{          
  },
  mounted () {
  },
  validations: {
    formField: {
      value:{
        required
      }
    }
  },
  created(){   
    this.getUserPermissions();
    this.getWeightage();
  },
  methods: {
    makeToast(message = '',title='Alert',variant='warning') {
      this.toastCount++
      this.$root.$bvToast.toast(message, {
        title:title,
        variant:variant,
        autoHideDelay: 3000
      })
    },
    async getUserPermissions(){
      let response = await api.post("users/user-permissions");
      const permissions = [];
      if (response.status == "success") {
        response.data[0].permission.forEach( function(element) {                
            permissions.push(element.action)
        }.bind(this));
        this.permission_list = permissions.includes("setting_weightage");
          if(this.permission_list == true || this.permission_add == true){
              this.permission_edit = permissions.includes("setting_weightage"); 
          }else if(response.data[0].role == 'super_admin'){
              this.superAdmin = true;
          }else{
              this.makeToast("Permission denied","Alert","warning",6000);
              this.$router.push({name: 'Admin Dashboard'});
          }
      }      
  },        
    async getWeightage(){        
      let response = await api.post('contact/weightage-list',{'id':this.$route.params.id});
      if(!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

      if(response.status == 'success'){
        this.formField = response.data;  
      }
   },
   async edit(){
    this.$v.$touch();
    if (this.$v.$invalid) {
      this.submitStatus = 'ERROR'
    } else{
      let response = await api.post('contact/weightage-edit', this.formField);
      if (!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

      if(response.status=='success'){
        this.makeToast(response.message,'Success','success');
        this.$router.push({name:"Weightage List"})
      }else{
          this.makeToast(response.message,'Alert','danger');
      }
    }
  }
}
}


